import EnterpriseDetails from '@/types/enterprise-detail-info';
import { ENTERPRISE_ADMIN_PERMISSIONS, PERMISSIONS, userHasPermissionEnabled } from '@/utils/permissions';
import User from '@/types/user';

/**
 * This function checks if a user is an enterprise admin based on their
 * permissions and returns the enterprise details if they are.
 * @param {User} user User for which we're validating the access.
 * @returns the `EnterpriseDetails` object if the user is an enterprise admin and has the required
 * permissions enabled. Otherwise, it returns `undefined`.
 */
export const getAdminUserEnterpriseDetails = (user: User): EnterpriseDetails | undefined => {
  const permissions = ENTERPRISE_ADMIN_PERMISSIONS.filter(p => p !== PERMISSIONS.ENTERPRISE_ADMIN_DATA_UPLOAD);
  return user.enterprise != null && userHasPermissionEnabled(user, ...permissions) ? user.enterprise : undefined;
};

// TODO: Upload functionality - https://capintel.atlassian.net/browse/CONN-5402
export const onUpload = () => 'uploaded';
